import {
  RelationshipEnum,
  RoomStatus,
  SendingStatus,
  ServiceType,
  Sex,
  MemberStatus,
  ChatType,
  ChannelTypeEnum,
} from ".";

export enum WecomAddOriginType {
  /** 通过扫一扫添加 */
  BY_SCAN = 1,
  /** 通过搜索手机号添加 */
  SEARCH_TEL = 2,
  /** 对方通过名片分享添加 */
  BY_BUSINESS_CARD = 3,
  /** 通过群聊添加 */
  BY_ROOM = 4,
  /** 通过微信好友添加 */
  BY_WECHAT_FRIEND = 6,
  // 从另一个地方 copy 的
  /** 通过扫一扫添加 */
  BY_SCAN_51 = 51,
  BY_SCAN_122 = 122,
  BY_SCAN_103 = 103,
}

export type WecomOuterContact = {
  id?: string;
  account: string;
  add_time: number;
  avatar: string;
  corp_id: string;
  corp_name: string;
  corp_short_name: string;
  desc: string;
  email: string;
  job: string;
  mobile_list: string[];
  name: string;
  nickname: string;
  realname: string;
  remark: string;
  sex: Sex;
  source_info: {
    add_source: WecomAddOriginType;
    op_user_id: number;
    source_room_id: string;
  };
  status: number;
  user_id: string;
  from_user_id: string;
  external_user_id: string;
  service_type: ServiceType;
  relationship: RelationshipEnum;
};
export type WecomInnerContact = {
  id?: string;
  account: string;
  alias: string;
  avatar: string;
  email: string;
  job: string;
  mobile: string;
  name: string;
  realname: string;
  sex: number;
  user_id: string;
  init_status: number;
  from_user_id: string;
  service_type: ServiceType;
};

export type WecomRoom = {
  id?: string;
  room_avatar: string;
  member_list: WecomRoomMember[];
  room_announcement: string;
  room_id: string;
  room_createtime: number;
  room_ext_type: number;
  room_flag: number;
  room_is_collect: number;
  room_is_forbid_change_name: number;
  room_name: string;
  room_owner_id: string;
  from_user_id: string;
  status?: RoomStatus;
};

export type WecomRoomMember = {
  avatar: string;
  corp_id: string;
  corp_short_name: string;
  email: string;
  name: string;
  nickname: string;
  user_id: string;
  status: MemberStatus;
};

export enum WecomContactType {
  /** 内部联系人 */
  INNER_SINGLE = "INNER_SINGLE",
  /** 外部联系人 */
  OUTER_SINGLE = "OUTER_SINGLE",
  /** 外部群聊 */
  OUTER_ROOM = "OUTER_ROOM",
  /** 内部群聊 */
  INNER_ROOM = "INNER_ROOM",
  /** 系统消息 */
  SYSTEM = "SYSTEM",
  /** 微信客服 */
  WECHAT_CUSTOMER_SERVICE = "WECHAT_CUSTOMER_SERVICE",
}
export type WecomConversationDataType = {
  chat_id: string;
  team_id?: string;
  name?: string;
  avatar?: string;
  last_message: WecomMessageType;
  chat_type: WecomContactType;
  from_user_id?: string;
  // 是否置顶
  is_top?: number;
  // 未读数
  unread?: number;
  // 是否屏蔽
  is_shield?: number;
  conversation_robot_relation?: {
    robotId?: string;
  };
  // 是否托管
  is_trusteeship?: boolean;
  corp_id?: string;
  corp_short_name?: string;
  // 当前会话的对象
  another_id: string;
  /** 联系人信息 */
  contact?: WecomOuterContact | WecomInnerContact;
  /** 群聊信息 */
  room?: WecomRoom;
};

export type WecomFriendApplyData = {
  id: string;
  channelType: ChannelTypeEnum;
  apply_reason: string;
  avatar: string;
  corp_id: string;
  name: string;
  alias?: string;
  sex: Sex;
  union_id: string;
  user_id: string;
  apply_source: WecomAddOriginType;
  from_user_id: string;
  add_time: number;
  apply_time: number;
  accept_request_key?: string;
  is_accept?: boolean;
};

export enum WecomMsgType {
  /** 文本 */
  TEXT = 0,
  /** 文本 */
  TEXT_2 = 2,
  /** 聊天记录 */
  CHAT_RECORD = 4,
  /** 链接 */
  LINK = 13,
  /** 红包 */
  HONGBAO = 26,
  /** 企微团队通知 */
  ENTERPRISE_WECHAT_TEAM = 38,
  /** 企微语音通话 */
  WECHAT_CALL = 40,
  /** 好友卡片 */
  BUSINESS_CARD = 41,
  /** 小程序 */
  MINI_PROGRAM = 78,
  /** 企微图片 */
  WECOM_IMAGE = 14,
  /** 个微图片 */
  WECHAT_IMAGE = 101,
  /** 大文件 */
  BIG_FILE = 20,
  /** 大视频 */
  BIG_VIDEO = 22,
  /** 企微视频 */
  WECOM_VIDEO = 23,
  /** 微视频 */
  WECHAT_VIDEO = 103,
  /** 企微微信文件 */
  WECOM_FILE = 15,
  /** 个人微信文件 */
  WECHAT_FILE = 102,
  /** gif */
  GIF = 29,
  GIF_104 = 104,
  /** 位置 */
  LOCATION = 6,
  /** 语音 */
  AUDIO = 16,
  /** 视频号 */
  VIDEO_NUM = 141,
  /** 群发助手 */
  BROADCAST_ASSISTANT = 573,
  /** 系统提示消息 */
  SYSTEM_NOTICE = 1000,
  /** 语音通话 */
  MEETING_VOICE_CALL = 9001,
}

/**
 * 消息状态
 * 目前后端只使用了已撤回状态
 */
export enum MsgStatus {
  /** 发送中 */
  SENDING = "SENDING",
  /** 发送成功 */
  SENT = "SENT",
  /** 发送失败 */
  FAILED = "FAILED",
  /** 发送超时 */
  TIMEOUT = "TIMEOUT",
  /** 已撤回 */
  RECALLED = "RECALLED",
  /**
   * 撤回中
   * 只在前端显示状态使用而已,后端没有该状态
   */
  RECALLING = "RECALLING",
}
type ExcludeKeys<T, U> = Exclude<keyof T, keyof U>;

type WecomMessageCommonType = {
  chat_id: string;
  another_id: string;
  msg_server_id: string;
  msg_unique_identifier: string;
  msgtype: WecomMsgType;
  request_key?: string;
  sender_id: string;
  timestamp: number;
  from_user_id?: string;
  to_id?: string;
  chat_type?: ChatType;
  /** 消息发送状态 */
  sending_status?: SendingStatus;
  /** 调用发送消息方法时的所有参数，用于发送失败时重新调用发送方法发送 */
  send_message_params?: Record<string, any>;
  /** 标识此条消息是否为撤回的消息 */
  is_revoke?: boolean;
  invoke_msgtype?: number;
  invoke_msg_unique_identifier?: string;
  /** ai回复的ID */
  robot_task_id?: string;
  /** 是否点赞 */
  positive?: boolean;
  /** 消息状态 */
  msg_status?: MsgStatus;
  robotId?: string;
  /** 纠偏知识id */
  rectifyId?: string;
  /** 发送系统用户名 */
  send_sys_user_name?: string;
  /** 撤回系统用户名 */
  recall_sys_user_name?: string;
};
export type WecomMessageBaseType<T extends object> = WecomMessageCommonType & {
  [P in ExcludeKeys<T, WecomMessageCommonType>]?: T[P];
};

export type WecomTextMessageType = WecomMessageBaseType<{
  content: string;
  is_room_notice?: number;
}>;

export type WecomMixedMessageType = WecomMessageBaseType<{
  at_list: { nickname: string; user_id: string }[];
  content: string;
}>;

export type WecomLinkMessageType = WecomMessageBaseType<{
  title: string;
  desc: string;
  thumburl: string;
  url: string;
}>;

export type WecomFileMessageType = WecomMessageBaseType<{
  file_aeskey?: string;
  file_md5?: string;
  file_name: string;
  file_size?: number;
  file_url: string;
}>;
// eslint-disable-next-line @typescript-eslint/ban-types
export type WecomHongBaoMessageType = WecomMessageBaseType<{}>;

export type WecomBusinessCardMessageType = WecomMessageBaseType<{
  headimg: string;
  nickname: string;
  shared_id: string;
  detail: string;
}>;

export type WecomImageMessageType = WecomMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WecomMiniProgramMessageType = WecomMessageBaseType<{
  appid: string;
  cover_image_aeskey: string;
  cover_image_id: string;
  cover_image_md5: string;
  cover_image_size: number;
  headimg: string;
  title: string;
  desc: string;
  username: string;
}>;

export type WecomVideoMessageType = WecomMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WecomGifMessageType = WecomMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WecomLocationMessageType = WecomMessageBaseType<{
  detail: string;
  name: string;
  latitude: number;
  longitude: number;
  address: string;
  title: string;
  zoom: number;
}>;

export type WecomAudioMessageType = WecomMessageBaseType<{
  duration: number;
  file_url: string;
  voice_content?: string;
}>;

export type WecomVideoNumMessageType = WecomMessageBaseType<{
  channel_name: string;
  channel_url: string;
  encode_data: string;
  head_img_url: string;
  username: string;
  thumburl: string;
}>;

export type WecomSystemMessageType = WecomMessageBaseType<{
  content: string;
  system_msg_descrption?: string;
}>;

export type WecomBroadcastMessageType = WecomMessageBaseType<{
  notify_title: string;
  notify_msg_desc: string;
  notify_nickname: string;
}>;

export type WecomChatRecordTransferItem = {
  msgtype: WecomMsgType;
  content: string;
  senderAvatarUrl: string;
  senderName: string;
  timestamp: number;
  file_url?: string;
  file_size?: number;
  corp_name?: string;
};

export type WecomChatRecordMessageType = WecomMessageBaseType<{
  transferList: WecomChatRecordTransferItem[];
}>;

// eslint-disable-next-line @typescript-eslint/ban-types
export type WecomWechatCallMessageType = WecomMessageBaseType<{}>;

export type WecomMessageType =
  | WecomTextMessageType
  | WecomMixedMessageType
  | WecomImageMessageType
  | WecomGifMessageType
  | WecomFileMessageType
  | WecomLinkMessageType
  | WecomHongBaoMessageType
  | WecomBusinessCardMessageType
  | WecomMiniProgramMessageType
  | WecomVideoNumMessageType
  | WecomSystemMessageType
  | WecomBroadcastMessageType
  | WecomWechatCallMessageType
  | WecomSystemMessageType;
